import { Action } from '../../common/actions/core/action';
import { ActionHandler } from '../../common/actions/core/action-handler';

import { OpenPacketImmediateDeleteSuccessAction } from './packet-delete-immediate-success-dialog.action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ITimeoutService, IWindowService } from 'angular';

/* @ngInject */
export default class PacketDeleteImmediateSuccessDialog implements ActionHandler {
  private dialogElement;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $timeout: ITimeoutService,
    private $window: IWindowService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#packet-delete-immediate-success-dialog')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  handle(action: Action) {
    if (action instanceof OpenPacketImmediateDeleteSuccessAction) {
        this.openDialog();
    }
  }

  public onClose() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  private close() {
    this.dialogElement.close();
    this.$window.location.href = "/?buySuccess=1"
  }
}



// WEBPACK FOOTER //
// ./src/app/packet/packet-delete-immediate-success-dialog/packet-delete-immediate-success-dialog.controller.ts